import React, { useState } from 'react';

import './desktop-collection-product-list-template-style.scss';

import Typography from '@src/componentsNew/Typography/Typography';
import DesktopProductListFilter from '@src/componentsNew/Filter/DesktopProductListFilter/DesktopProductListFilter';
import DesktopProductListSortingFilter from '@src/componentsNew/Filter/DesktopProductListFilter/DesktopProductListSortingFilter';
import DesktopBasicProductList from '@src/componentsNew/ProductList/Basic/DesktopBasicProductList';

import useIsComDomain from '@src/hooks/useIsComDomain';

import { productsVariables } from '@components/ProductPage/ProductList/__generated__/products';
import { StockAvailability, ProductOrderField, OrderDirection } from '__generated__/globalTypes';
import { DESKTOP_PRODUCT_LIST_REQUEST_COUNT } from '@src/utils/constants';

type IProps = {
  collectionName: string;
  collectionGraphqlId?: string;
};

const DesktopCollectionProductListTemplate = ({ collectionName, collectionGraphqlId }: IProps) => {
  const isComDomain = useIsComDomain();

  const initialVariables = {
    collections: [collectionGraphqlId],
    stockAvailability: StockAvailability.IN_STOCK,
    sortBy: {
      field: ProductOrderField.POPULARITY,
      direction: OrderDirection.DESC,
    },
    first: DESKTOP_PRODUCT_LIST_REQUEST_COUNT,
    ...(isComDomain && { isMgs: true }),
  };

  const [variables, setVariables] = useState<productsVariables>(initialVariables);
  const [numOfProducts, setNumOfProducts] = useState<number>(0);

  return (
    <div className="desktop-collection-product-list-template-wrapper">
      <div className="collection-product-list-top-wrapper">
        <div className="content-area">
          <Typography variant="h6" component="h6">
            {collectionName}
          </Typography>
          {numOfProducts > 0 ? (
            <div className="sorting-filter-area">
              <Typography
                variant="body1"
                component="span"
                style={{ color: '#666666' }}
              >{`${numOfProducts} Items`}</Typography>

              <DesktopProductListSortingFilter variables={variables} setVariables={setVariables} />
            </div>
          ) : null}
        </div>
        <div className="divider" />
      </div>

      <div className="main-area">
        <div className="desktop-prodcut-list-filter-wrapper">
          <DesktopProductListFilter
            initialVariables={initialVariables}
            variables={variables}
            setVariables={setVariables}
          />
        </div>

        <div className={`products-area ${numOfProducts === 0 ? 'no-product' : ''}`}>
          <DesktopBasicProductList
            initialVariables={initialVariables}
            variables={variables}
            setNumOfProducts={setNumOfProducts}
          />
        </div>
      </div>
    </div>
  );
};

export default DesktopCollectionProductListTemplate;
